import React, { useState, useEffect } from 'react';
import { FaPlus, FaSave, FaEdit } from "react-icons/fa";
import ISODropdown from '../../DropDowns/ISODropdown/IsoDropdown';
// import CompanyDropdown from "../../DropDowns/CompanyDropdown/CompanyDropdown";
import Dialog from "../FormDialog/Dialog";
import AssetTypeDropdown from "../../DropDowns/AssetTypeDropdown/AssetType";
import CommunicationTypeDropdown from '../../DropDowns/CommunicationTypeDropdown/CommunicationType';
import ControlTypeDropdown from '../../DropDowns/ControlTypeDropdown/ControlType';
import SchedulingTypeDropdown from '../../DropDowns/ShedulingTypeDropdown/ShedulingType';
// import TimeZoneDropdown from '../../DropDowns/TimeZoneDropdown/TimeZoneDropdown';
import StateDropdown from '../../DropDowns/StateTypeDropdown/StateDropdown';
import { getUserInfo } from "../../../services/authService-sighup";
import { ASSET_TAB } from '../constants/constants';
import LifecycelStatusDropdown from "../../DropDowns/GroupStatusDropdown/GroupStatusDropdown";
interface AssetFormProps {
  onSaveAsset: (newAsset: any) => void;
  onSaveChanges: (updatedAsset: any) => void;
  editIndex: number | null;
  asset?: any;
  isoData: any[];
  selectedAsset: any | null;
  setSelectedAsset: (asset: any) => void;
  className?: string;
  handleApiError: (err: any, fallbackTitle: string) => void;
  onClearSelection: () => void;
  // onFormDirtyChange?: (isDirty: boolean) => void;
  onDirtyChange: (dirty: boolean) => void;
  onModeChange: (mode: 'create' | 'edit' | 'view' | null) => void;
  registerTabSwitchGuard?: (guard: () => boolean | Promise<boolean>) => void;
  onDeleteAsset: () => void;
  canDelete?: boolean; 


}
const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toISOString().split("T")[0]; // Get YYYY-MM-DD format
};

const AssetForm: React.FC<AssetFormProps> = ({
  onSaveAsset,
  onSaveChanges,
  editIndex,
  asset,
  isoData,
  selectedAsset,
  className = "",
  setSelectedAsset,
  handleApiError,
  onClearSelection,
  onDirtyChange,
  onModeChange,
  registerTabSwitchGuard,
  onDeleteAsset,
  canDelete = false

}) => {

  const [company_id, setcompany_id] = useState(asset?.company_id || '');
  const [asset_name, setasset_name] = useState(asset?.asset_name || '');
  const[asset_id,setasset_id] = useState(asset?.asset_id || 0);
  const[group_status_code,setgroup_status_code]= useState(asset?.group_status_code || '');
  const [city, setCity] = useState(asset?.city || '');
  const [latitude, setLatitude] = useState(asset?.latitude || 0);
  const [longitude, setLongitude] = useState(asset?.longitude || 0);
  const [nameplate_rating_mw, setnameplate_rating_mw] = useState(asset?.nameplate_rating_mw || 0);
  const [max_energy_mwh, setmax_energy_mwh] = useState(asset?.max_energy_mwh || 0);
  const [ess_mw, setess_mw] = useState(asset?.ess_mw || 0);
  const [solar_mw, setsolar_mw] = useState(asset?.solar_mw || 0.0);
  const [commercial_operating_date, setcommercial_operating_date] = useState(
    asset?.commercial_operating_date ? formatDate(asset.commercial_operating_date) : ''
  );
  const [initial_sync_date, setinitial_sync_date] = useState(
    asset?.initial_sync_date ? formatDate(asset.initial_sync_date) : ''
  );
  const [retirement_date, setretirement_date] = useState(
    asset?.retirement_date ? formatDate(asset.retirement_date) : ''
  );
  
  const [generation_subtype_code, setgeneration_subtype_code] = useState(asset?.generation_subtype_code|| '');
  const [iso_code, setIso_code] = useState(asset?.iso_code || '');
  // const [iso_code, setIso_code] = useState("");
  const [state_code, setstate_code] = useState(asset?.state_code || '');
  const [time_zone_code, settime_zone_code] = useState(asset?.time_zone_code || '');
  // const [time_zone_code, settime_zone_code] = useState("");
  const [control_type_code, setControlTypeCode] = useState(asset?.control_type_code || '');
  const [communication_type_code, setCommunicationTypeCode] = useState(asset?.communication_type_code || '');
  const [scheduling_type_code, setSchedulingTypeCode] = useState(asset?.scheduling_type_code || '');
  const [isEditMode, setIsEditMode] = useState(false);
  const [user, setUser] = useState<{ fullName: string; email: string } | null>(null);
  const [activeField, setActiveField] = useState<string | null>(null);
  const [isViewMode, setIsViewMode] = useState(false);  
  const [modifiedFields, setModifiedFields] = useState<Record<string, boolean>>({});
  // const [company_name, setcompany_name] = useState<string>("");
  const [formState, setFormState] = useState({
    assetName: '',
    companyId: '', // store company_id
    isoCode: '',
    generationCode:''
  });
  const [errors, setErrors] = useState({
    company_id: false,
    asset_name: false,
    iso_code: false,
    generation_subtype_code: false,
  });
  
 
  

  
  const [dialog, setDialog] = useState<{
    open: boolean;
    title: string;
    message: React.ReactNode;
    confirmButtonText: string;
    cancelButtonText?: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }>({
    open: false,
    title: "",
    message: "",
    confirmButtonText: "",
    onConfirm: () => {},
  });

  const closeDialog = () => {
    setDialog({
      open: false,
      title: "",
      message: "",
      confirmButtonText: "",
      onConfirm: () => {},
    });
  };
  

  useEffect(() => {
    if (selectedAsset) {
      setFormState({
        assetName: selectedAsset.asset_name,
        companyId: selectedAsset.company_id,
        isoCode: selectedAsset.iso_code,
        generationCode: selectedAsset.generation_subtype_code
      });
    }
  }, [selectedAsset]);
  // useEffect(() => {
  //   if (!selectedAsset) {
  //     onModeChange('create');
  //   }
  // }, [selectedAsset]);
  

  // const handleISOChange = (selectedISO: string) => {
  //   setIso_code(selectedISO);
  // };

  // const handleCompanyChange = (selectedCompanyName: string, selectedCompanyId: number) => {
  //   setcompany_id(selectedCompanyId || null);
  //   setcompany_name(selectedCompanyName); // <== missing earlier!
  //   console.log("Selected Company ID:", selectedCompanyId);
  //   console.log("Selected Company Name:", selectedCompanyName);
  // };
  
  // const handleCompanyChange = (selectedCompanyName: string, selectedCompanyId: number) => {
  //   setcompany_id(selectedCompanyId);
  //   // setcompany_name(selectedCompanyName);
  //   console.log("Selected Company ID:", selectedCompanyId);
  //   console.log("Selected Company Name:", selectedCompanyName);
  // };
  
  
 
  useEffect(() => {
    if (selectedAsset && !isEditMode) {
      setcompany_id(selectedAsset.company_code || '');
      setasset_name(selectedAsset.asset_name || '');
      setasset_id(selectedAsset.asset_id || 0);
      setCity(selectedAsset.city || '');
      setLatitude(selectedAsset.latitude || '');
      setLongitude(selectedAsset.longitude || '');
      setnameplate_rating_mw(selectedAsset.nameplate_rating_mw || '');
      setmax_energy_mwh(selectedAsset.max_energy_mwh || '');
      setess_mw(selectedAsset.ess_mw || '');
      setsolar_mw(selectedAsset.solar_mw || '');
      setcommercial_operating_date(formatDate(selectedAsset.commercial_operating_date) || '');
      setinitial_sync_date(formatDate(selectedAsset.initial_sync_date) || '');
      setretirement_date(formatDate(selectedAsset.retirement_date) || '');
      setgroup_status_code(selectedAsset.group_status_code || '');
      setgeneration_subtype_code(selectedAsset.generation_subtype_code|| '');
      setIso_code(selectedAsset.iso_code || '');
      setstate_code(selectedAsset.state_code || '');
      settime_zone_code(selectedAsset.time_zone_code || '');
      setCommunicationTypeCode(selectedAsset.communication_type_code || '');
      setControlTypeCode(selectedAsset.control_type_code || '');
      setSchedulingTypeCode(selectedAsset.scheduling_type_code || '')
      setIsViewMode(true);
      onDirtyChange(false);
    } else if (selectedAsset && isEditMode) {
      setcompany_id(selectedAsset.company_code || '');
      setasset_name(selectedAsset.asset_name || '');
      setasset_id(selectedAsset.asset_id || 0)
      setCity(selectedAsset.city || '');
      setLatitude(selectedAsset.latitude || '');
      setLongitude(selectedAsset.longitude || '');
      setnameplate_rating_mw(selectedAsset.nameplate_rating_mw || '');
      setmax_energy_mwh(selectedAsset.max_energy_mwh || '');
      setess_mw(selectedAsset.ess_mw || '');
      setsolar_mw(selectedAsset.solar_mw || '');
      setcommercial_operating_date(formatDate(selectedAsset.commercial_operating_date) || '');
      setinitial_sync_date(formatDate(selectedAsset.initial_sync_date) || '');
      setretirement_date(formatDate(selectedAsset.retirement_date) || '');
      setgroup_status_code(selectedAsset.group_status_code || '');
      setgeneration_subtype_code(selectedAsset.generation_subtype_code|| '');
      setIso_code(selectedAsset.iso_code || '');
      setstate_code(selectedAsset.state_code || '');
      settime_zone_code(selectedAsset.time_zone_code || '');
      setCommunicationTypeCode(selectedAsset.communication_type_code || '');
      setControlTypeCode(selectedAsset.control_type_code || '');
      setSchedulingTypeCode(selectedAsset.scheduling_type_code || '')
      setIsEditMode(false);
      setIsViewMode(true);
    }
  }, [selectedAsset]);

  useEffect(() => {
    const fetchUserInfo = () => {
      const userInfo = getUserInfo();
      if (userInfo) {
        setUser({
          fullName: userInfo.fullName || "Unknown User",
          email: userInfo.email || "",
        });
      }
    };
    fetchUserInfo();
  }, []);


  const createdBy = user ? `${user.email || user.fullName}` : "Unknown User";
  const modifiedBy = user ? `${user.email || user.fullName}` : "Unknown User";

  // const validateFields = () => {
  //   const newErrors = {
  //     company_id: !company_id,
  //     company_name: false, 
  //     asset_name: !asset_name,
  //     iso_code: !iso_code.trim(),
  //   };
  
  //   setErrors(newErrors);
  //   return !Object.values(newErrors).some((error) => error);
  // };  
  const validateFields = () => {
    const newErrors = {
      company_id: company_id === null || company_id === undefined,
      // company_name: false,
      asset_name: !asset_name,
      iso_code: !iso_code.trim(),
      generation_subtype_code: !generation_subtype_code.trim(),
    };
  
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error);
  };
  const handleSaveNewAsset = async () => {
    const isValid = validateFields();
    if (!isValid) {
      console.log("Validation failed, aborting save.");
      setDialog({
        open: true,
        title: ASSET_TAB.VALIDATION.MISSING_INFO_TITLE,
        message: ASSET_TAB.VALIDATION.MISSING_INFO_MESSAGE,
        confirmButtonText: "Close",
        onConfirm: closeDialog,
      });
      return;
    }
    if (group_status_code?.toLowerCase() === 'retired' && !retirement_date) {
      setDialog({
        open: true,
        title: "Missing Retirement Date",
        message: "Retirement Date is required when status is Retired.",
        confirmButtonText: "OK",
        onConfirm: closeDialog,
      });
      return;
    }
  
    const newAsset = {
      company_id: company_id,
      asset_name: asset_name || null,
      asset_id:asset_id || null,
      iso_code: iso_code || null,
      generation_subtype_code: generation_subtype_code || null,
      state_code: state_code || null,
      city: city || null,
      latitude: latitude || null,
      longitude: longitude || null,
      nameplate_rating_mw: nameplate_rating_mw || null,
      max_energy_mwh: max_energy_mwh || null,
      ess_mw: ess_mw || null,
      solar_mw: solar_mw || null,
      commercial_operating_date: commercial_operating_date || null,
      initial_sync_date: initial_sync_date || null,
      retirement_date: retirement_date || null,
      group_status_code:group_status_code|| null,
      time_zone_code: time_zone_code || null,
      control_type_code: control_type_code || null,
      communication_type_code: communication_type_code || null,
      scheduling_type_code: scheduling_type_code || null,
      group_description: '',
      sys_created_by: createdBy,
      sys_modified_by: modifiedBy,
      sys_created_date: new Date().toISOString(),
      sys_modified_date: new Date().toISOString(),
    };  
    try {
      await onSaveAsset(newAsset);
      resetForm();
      onDirtyChange(false);
    } catch (error) {
      handleApiError(error, 'Failed to create asset');
    }
  };
  
  const handleSaveEditedAsset = async () => {
    if (!asset_name) {
      return; 
    }
    if (group_status_code?.toLowerCase() === 'retired' && !retirement_date) {
      setDialog({
        open: true,
        title: "Missing Retirement Date",
        message: "Retirement Date is required when status is Retired.",
        confirmButtonText: "OK",
        onConfirm: closeDialog,
      });
      return;
    }
    const updatedAssetRaw = {
      asset_name,
      asset_id,
      generation_subtype_code,
      iso_code,
      state_code,
      city,
      latitude,
      longitude,
      nameplate_rating_mw,
      max_energy_mwh,
      ess_mw,
      solar_mw,
      commercial_operating_date,
      initial_sync_date,
      retirement_date,
      group_status_code,
      time_zone_code,
      communication_type_code,
      control_type_code,
      scheduling_type_code,
      group_description: '',
      sys_created_by: createdBy,
      sys_modified_by: modifiedBy,
      sys_created_date: new Date().toISOString(),
      sys_modified_date: new Date().toISOString(),
    };
    
    const updatedAsset = Object.fromEntries(
      Object.entries(updatedAssetRaw).filter(
        ([, value]) => value !== '' && value !== null && value !== undefined
      )
    );
    
    try {
      await onSaveChanges(updatedAsset);  
      resetForm();
      onDirtyChange(false);
      setSelectedAsset(null);
      setIsEditMode(false);
      onDirtyChange(false);
    } catch (err) {
      handleApiError(err, 'Failed to update asset');
    }
    
  };
  const resetForm = () => {
    setcompany_id('');
    setasset_name('');
    setasset_id('');
    setgeneration_subtype_code('');
    setIso_code('');
    setstate_code('');
    setCity('');
    setLatitude('');
    setLongitude('');
    setnameplate_rating_mw('');
    setmax_energy_mwh('');
    setess_mw('');
    setsolar_mw('');
    setcommercial_operating_date('');
    setinitial_sync_date('');
    setretirement_date('');
    setgroup_status_code('');
    settime_zone_code('');
    setControlTypeCode('');
    setCommunicationTypeCode('');
    setSchedulingTypeCode('');
    setIsEditMode(false);
    setIsViewMode(false);
    onDirtyChange(false); 
    onModeChange(null);
    setModifiedFields({});

    // onClearSelection();
  };
  const resetToSelectedCompany = () => {
    if (selectedAsset) {
      setcompany_id(selectedAsset.company_code || '');
      setasset_name(selectedAsset.asset_name || '');
      setasset_id(selectedAsset.asset_id || '');
      setCity(selectedAsset.city || '');
      setLatitude(selectedAsset.latitude || '');
      setLongitude(selectedAsset.longitude || '');
      setnameplate_rating_mw(selectedAsset.nameplate_rating_mw || '');
      setmax_energy_mwh(selectedAsset.max_energy_mwh || '');
      setess_mw(selectedAsset.ess_mw || '');
      setsolar_mw(selectedAsset.solar_mw || '');
      setcommercial_operating_date(formatDate(selectedAsset.commercial_operating_date) || '');
      setinitial_sync_date(formatDate(selectedAsset.initial_sync_date) || '');
      setretirement_date(formatDate(selectedAsset.retirement_date) || '');
      setgroup_status_code(selectedAsset.group_status_code || '');
      setgeneration_subtype_code(selectedAsset.generation_subtype_code|| '');
      setIso_code(selectedAsset.iso_code || '');
      setstate_code(selectedAsset.state_code || '');
      settime_zone_code(selectedAsset.time_zone_code || '');
      setCommunicationTypeCode(selectedAsset.communication_type_code || '');
      setControlTypeCode(selectedAsset.control_type_code || '');
      setSchedulingTypeCode(selectedAsset.scheduling_type_code || '')
      setIsEditMode(false);
      setIsViewMode(true);
      onDirtyChange(false);
      setModifiedFields({});
      onModeChange("view");
    }
  };
  
  const handleCancelClick = () => {
    setDialog({
      open: true,
      title: "Cancel Editing?",
      message: "Are you sure you want to discard changes?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        resetToSelectedCompany();
        setModifiedFields({});

      },
      onCancel: closeDialog,
    });
  };
  const handleNew = () => {
    setDialog({
      open: true,
      title: ASSET_TAB.DIALOGS.CONFIRM_NEW_TITLE,
      message: ASSET_TAB.DIALOGS.CONFIRM_NEW_MESSAGE,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        resetForm();
        setSelectedAsset(null);
        // onModeChange('create');
        onDirtyChange(false);
        setIsEditMode(false);
        onClearSelection();
      },
      onCancel: closeDialog,
    });
  };

  const handleEdit = () => {
    // if (!selectedAsset) return;
    setIsViewMode(false);
    setIsEditMode(true);
    onDirtyChange(true); 
    onModeChange('edit');
    setModifiedFields({});

  };

  const handleDeleteClick = () => {
    if (!selectedAsset) return;
  
    setDialog({
      open: true,
      title: "Confirm Delete",
      message: `Are you sure you want to delete asset "${selectedAsset.asset_name}"?`,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        onDeleteAsset();   // 👈 call parent
      },
      onCancel: closeDialog,
    });
  };



  return (
    <form className="h-full" onSubmit={(e) => e.preventDefault()}>
      <div className="h-full bg-white p-8 rounded-lg shadow-lg font-poppins w-full">
        {dialog.open && (
         <Dialog
         title={dialog.title}
         message={dialog.message}
         confirmButtonText={dialog.confirmButtonText}
         cancelButtonText={dialog.cancelButtonText}
         onConfirm={dialog.onConfirm}
         onCancel={dialog.onCancel}
         onClose={closeDialog} 
       />
        )}

{/* <div className="grid grid-cols-1 sm:grid-cols-1 gap-6 mb-2">
  <div className="mt"> */}
<div className="flex justify-between items-center mb-4">

<div>
{isEditMode && canDelete && (
  <button
    onClick={handleDeleteClick}
    type="button"
    className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600"
  >
    Delete
  </button>
)}
</div>

<div className="flex gap-3">
    {selectedAsset ? (
    <>
      {!isEditMode ? (
        <>
          <button
            onClick={handleNew}
            className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-300 shadow-md transform hover:scale-105"
          >
            <FaPlus className="mr-2" /> New
          </button>

          <button
            onClick={handleEdit}
            disabled={isEditMode}
            className={`flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-300 shadow-md transform hover:scale-105 ${
              isEditMode ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <FaEdit className="mr-2" /> Edit
          </button>
        </>
      ) : (
        <>
          <button
            onClick={() => {
              setDialog({
                open: true,
                title: ASSET_TAB.DIALOGS.CONFIRM_EDIT_TITLE,
                message: ASSET_TAB.DIALOGS.CONFIRM_EDIT_MESSAGE,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                onConfirm: () => {
                  closeDialog();
                  handleSaveEditedAsset();
                  setModifiedFields({});
                },
                onCancel: closeDialog,
              });
            }}
            className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-300 shadow-md transform hover:scale-105"
          >
            <FaSave className="w-4 h-4" /> Save
          </button>
          <button
            onClick={handleCancelClick}
            className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-300 shadow-md transform hover:scale-105"
          >
           Cancel
          </button>
        </>
      )}
    </>
  ) : (
    // Create Button
    <button
      onClick={() => {
        const isValid = validateFields();
        if (!isValid) {
          setDialog({
            open: true,
            title: ASSET_TAB.VALIDATION.MISSING_INFO_TITLE,
            message: ASSET_TAB.VALIDATION.MISSING_INFO_MESSAGE,
            confirmButtonText: "Close",
            onConfirm: closeDialog,
          });
          return;
        }

        setDialog({
          open: true,
          title: ASSET_TAB.DIALOGS.CONFIRM_CREATE_TITLE,
          message: ASSET_TAB.DIALOGS.CONFIRM_CREATE_MESSAGE,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          onConfirm: () => {
            closeDialog();
            handleSaveNewAsset();
          },
          onCancel: closeDialog,
        });
      }}
      className="flex items-center gap-2 w-auto px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300 shadow-md transform hover:scale-105"
    >
      <FaPlus className="w-4 h-4" /> Create
    </button>
  )}
</div>
</div>

  {/* </div>
</div> */}

        {/* Form Rows */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-600 mb-1">Asset Name<span className="text-red-500 text-lg align-top ml-1">*</span></label>
            <input
            type="text"
            value={asset_name}
            // onChange={(e) => setasset_name(e.target.value)}
            onChange={(e) => {
              const value = e.target.value;
              setasset_name(value);
              onDirtyChange(true);
              setModifiedFields(prev => ({ ...prev, asset_name: true }));
            }}
            placeholder="Asset Name"
            disabled={!isEditMode && selectedAsset}
            onFocus={() => setActiveField("asset_name")}
          className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200  
  ${errors.asset_name && !asset_name
    ? "border-red-500 focus:ring-red-500"
    : isEditMode && (activeField === "asset_name" || modifiedFields.asset_name)
      ? "border-green-500 focus:ring-2 focus:ring-green-500"
      : !isEditMode
        ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
        : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
  }`}/>

          </div>


          <div>
            <label className="block text-gray-600 mb-1">Asset Type<span className="text-red-500 text-lg align-top ml-1">*</span></label>
            <AssetTypeDropdown
              selectedAssetType={generation_subtype_code}
              onFocus={() => setActiveField("selectedAsset")}
              disabled={!isEditMode && selectedAsset}
              // onAssetTypeChange={setgeneration_subtype_code}
              onAssetTypeChange={(value) => {
                setgeneration_subtype_code(value);
                onDirtyChange(true);
                setModifiedFields(prev => ({ ...prev, selectedAsset: true }));
              }}
              className={`w-68 p-1 mt-[-4px] border rounded-lg shadow-inner text-sm transition-all duration-200  
              ${errors.generation_subtype_code && !generation_subtype_code
                  ? "border-red-500 focus:ring-red-500"
                  : isEditMode && (activeField === "selectedAsset" || modifiedFields.selectedAsset)
                ? "border-green-500 focus:ring-2 focus:ring-green-500"
                  : !isEditMode
                    ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                    : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                }`}
            />
          </div>

        </div>

        <div className={`grid grid-cols-1 ${selectedAsset ? 'sm:[grid-template-columns:repeat(2,minmax(0,1fr))_auto]' : 'sm:grid-cols-2'} gap-6 mt-4`}>
          <div>
            {/* <label className="block text-gray-600 mb-1">Company</label>
            <CompanyDropdown
  selectedCompany={company_name}
  onCompanyChange={handleCompanyChange}
  disabled={!isEditMode && selectedAsset}
  className={`w-68 p-3 border rounded-lg shadow-inner text-sm transition-all duration-200
    ${!isEditMode 
      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
      : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
    }`}
/> */}
<label className="block text-gray-600 mb-1">ISO<span className="text-red-500 text-lg align-top ml-1">*</span></label>
            {/* <ISODropdown
            selectedISO={iso_code}
            onISOChange={(iso) => setIso_code(iso)}
            disabled={!isEditMode && selectedAsset} */}
            <ISODropdown
              selectedISO={iso_code}
              onISOChange={(iso, isoObj) => {
                setIso_code(iso);
                settime_zone_code(isoObj?.tz_standard || "");
                onDirtyChange(true);  // set standard time zone
                setModifiedFields(prev => ({ ...prev, iso_code: true }));

              }}
              onFocus={() => setActiveField("iso_code")}
              disabled={!isEditMode && selectedAsset}
              className={`w-full p-1 mt-[-4px] border rounded-lg shadow-inner text-sm transition-all duration-200
            ${errors.iso_code && !iso_code
                  ? "border-red-500 focus:ring-red-500"
                  : isEditMode && (activeField === "iso_code"|| modifiedFields.iso_code)
                ? "border-green-500 focus:ring-2 focus:ring-green-500"
                  : !isEditMode
                    ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                    : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                }`}

            />


          </div>
          <div>
  <label className="block text-gray-600 mb-1">Time Zone</label>
  <input
    type="text"
    placeholder="Time Zone"
    value={time_zone_code}
    readOnly
    disabled
    className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 bg-[#f9f9f9] text-gray-800 border-gray-300`}
  />
</div>
{selectedAsset && (
  <div className="flex items-center space-x-2 text-md text-gray-800 mt-4 p-3">
    <span className="font-medium text-gray-600 ">Asset ID :</span>
    <span>{asset_id || "N/A"}</span>
  </div>
)}

</div>

        {/* Grouped Location and State */}
        <div className="p-6 bg-[#f9f9f9] border border-gray-300 rounded-lg shadow-sm mt-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-600 mb-1">Location</label>
              <input
              type="text"
              value={city}
              // onChange={(e) => setCity(e.target.value)}
              onChange={(e) => {
                setCity(e.target.value);
                onDirtyChange(true); 
                setModifiedFields(prev => ({ ...prev, city: true }));

              }}
              placeholder="Location"
              onFocus={() => setActiveField("city")}
              disabled={!isEditMode && selectedAsset}
              className={`w-full p-3 pl-4 pr-10 border rounded-lg text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
              ${!isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : isEditMode && (activeField === "city"|| modifiedFields.city)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                  : "border-blue-500 focus:ring-2 focus:ring-blue-500 bg-white text-black"
              }
                ${className}`}
            />


            </div>

            <div>
      <label className="block text-gray-600 mb-1">State</label>
      <StateDropdown
        selectedState={state_code}
        // onStateChange={(state_code) => setstate_code(state_code)}
        onStateChange={(state_code) => {
          setstate_code(state_code);
          onDirtyChange(true);
          setModifiedFields(prev => ({ ...prev, state_code: true }));
 
        }}
        onFocus={() => setActiveField("state_code")}
        disabled={!isEditMode && selectedAsset}
        className={`w-68 p-1 mt-[-2px] border rounded-lg shadow-inner text-sm transition-all duration-200
          ${!isEditMode
            ? "bg-[#f9f9f9] text-gray-800 border-gray-300" 
            : isEditMode && (activeField === "state_code"|| modifiedFields.state_code)
              ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
              : "border-blue-500 focus:ring-2 focus:ring-blue-500 bg-white text-black" 
            // : "bg-f9f9f9 text-black border-blue-500 focus:ring-2 focus:ring-blue-500"  
          }`}
      />
    </div>
          </div>
          {/* Latitude, Longitude, and Time Zone Group */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
            <div>
              <label className="block text-gray-600 mb-1">Latitude</label>
              <input
  type="number"
  value={latitude}
  onFocus={() => setActiveField("latitude")}
  disabled={!isEditMode && selectedAsset}
  // onChange={(e) => setLatitude(parseFloat(e.target.value) || '')}
  onChange={(e) => {
    setLatitude(parseFloat(e.target.value) || '');
    onDirtyChange(true); 
    setModifiedFields(prev => ({ ...prev, latitude: true }));

  }}
  placeholder="Latitude"
  className={`w-full p-3 pl-4 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none
    ${!isEditMode || !selectedAsset 
      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
      : isEditMode && (activeField === "latitude"|| modifiedFields.latitude)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                  : "bg-white text-black border-blue-500"}
       
    ${className}`}
/>

            </div>

            <div>
              <label className="block text-gray-600 mb-1">Longitude</label>
              <input
  type="number"
  value={longitude}
  // onChange={(e) => setLongitude(parseFloat(e.target.value) || '')}
  onChange={(e) => {
    setLongitude(parseFloat(e.target.value) || '');
    onDirtyChange(true); 
    setModifiedFields(prev => ({ ...prev, longitude: true }));

  }}
  onFocus={() => setActiveField("longitude")}
  placeholder="Longitude"
  className={`w-full p-3 pl-4 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none
    ${!isEditMode 
      ? "bg-[#f9f9f9] text-gray-800 border-gray-300" 
      : isEditMode && (activeField === "longitude"|| modifiedFields.longitude)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                  : "bg-white text-black border-blue-500"}     
    ${className}`}
/>

            </div>

{/* <div>
              <label className="block text-gray-600 mb-1">Time Zone</label>
            <TimeZoneDropdown
            selectedTimeZone={time_zone_code}
            onTimeZoneChange={(time_zone_code ) => settime_zone_code(time_zone_code)}
             disabled={!isEditMode && selectedAsset}
             
            className={`w-68 p-3 border rounded-lg shadow-inner text-sm transition-all duration-200
            ${!isEditMode
              ? "bg-[#f9f9f9] text-gray-800 border-gray-300"  
              : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"  
            }`}
          
          />

            </div> */}
          </div>
        </div>


        <div className="p-6 bg-[#f9f9f9] border border-gray-300 rounded-lg shadow-sm mt-5">
          {/* Max Energy MWh, ESS MW, and Solar MW Group */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6  ">
            {/* Max Energy MWh */}
            <div>
              <label className="block text-gray-600 mb-1">Max MWh</label>
              <input
  type="number"
  value={max_energy_mwh}
  onFocus={() => setActiveField("max_energy_mwh")}
  disabled={!isEditMode && selectedAsset} 
  // onChange={(e) => setmax_energy_mwh(e.target.value)}
  onChange={(e) => {
    setmax_energy_mwh(e.target.value);
    onDirtyChange(true); 
    setModifiedFields(prev => ({ ...prev, max_energy_mwh: true }));
  }}
  placeholder="Max Energy MWh"
  className={`w-full p-3 pl-4 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
    ${!isEditMode 
      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
      : isEditMode && (activeField === "max_energy_mwh"|| modifiedFields.max_energy_mwh)
      ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
      : "bg-white text-black border-blue-500"}  
    ${className}`}
/>



            </div>

            {/* ESS MW */}
            <div>
              <label className="block text-gray-600 mb-1">ESS MW</label>
              <input
  type="number"
  value={ess_mw}
  onFocus={() => setActiveField("ess_mw")}
  disabled={!isEditMode && selectedAsset}
  // onChange={(e) => setess_mw(e.target.value)}
  onChange={(e) => {
    setess_mw(e.target.value);
    onDirtyChange(true); 
    setModifiedFields(prev => ({ ...prev, ess_mw: true }));
  }}
  placeholder="ESS MW"
  className={`w-full p-3 pl-4 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
    ${!isEditMode 
      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
      : isEditMode && (activeField === "ess_mw" || modifiedFields.ess_mw)
      ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
      : "bg-white text-black border-blue-500"}
    ${className}`}
/>

            </div>

            {/* Solar MW */}
            <div>
              <label className="block text-gray-600 mb-1">Solar MW</label>
              <input
  type="number"
  value={solar_mw}
  disabled={!isEditMode && selectedAsset}
  // onChange={(e) => setsolar_mw(e.target.value)}
  onChange={(e) => {
    setsolar_mw(e.target.value);
    onDirtyChange(true); 
    setModifiedFields(prev => ({ ...prev, solar_mw: true }));
  }}
  placeholder="Solar MW"
  onFocus={() => setActiveField("solar_mw")}
  className={`w-full p-3 pl-4 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
    ${!isEditMode 
      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
      : isEditMode && (activeField === "solar_mw"|| modifiedFields.solar_mw)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                  : "bg-white text-black border-blue-500"}
      
    ${className}`}
/>

            </div>

            {/* Name Plate Rating */}
            <div>
              <label className="block text-gray-600 mb-1">Name Plate Rating MW</label>
              <input
  type="number"
  value={nameplate_rating_mw}
  onFocus={() => setActiveField("nameplate_rating_mw")}
  disabled={!isEditMode && selectedAsset}
  // onChange={(e) => setnameplate_rating_mw(e.target.value)}
  onChange={(e) => {
    setnameplate_rating_mw(e.target.value);
    onDirtyChange(true); 
    setModifiedFields(prev => ({ ...prev, nameplate_rating_mw: true }));
  }}
  placeholder="Enter Name Plate Rating"
  className={`w-full p-3 pl-4 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
    ${!isEditMode 
      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
      : isEditMode && (activeField === "nameplate_rating_mw"|| modifiedFields.nameplate_rating_mw)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                  : "bg-white text-black border-blue-500"}
      
    ${className}`}
/>

            </div>
          </div>
        </div>
        <div className="p-6 bg-[#f9f9f9] border border-gray-300 rounded-lg shadow-sm mt-5">
          {/* Date Fields Group */}
          <div className="grid grid-cols-1 gap-6">
  {/* LifeCycle Status - Full width on top */}
  <div>
  <label className="block text-gray-600 mb-1">LifeCycle Status</label>
  <LifecycelStatusDropdown
    selectedStatus={group_status_code}
    onStatusChange={(value) => {
      setgroup_status_code(value);
      onDirtyChange(true);
      setModifiedFields(prev => ({ ...prev, group_status_code: true }));
    }}
    onFocus={() => setActiveField("group_status_code")}
    disabled={!isEditMode && !!selectedAsset}
    className={`w-[48%] p-1 pl-2 border rounded-lg text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
      ${
        !isEditMode
          ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
          : isEditMode &&
            (activeField === "group_status_code" || modifiedFields.group_status_code)
          ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
          : "border-blue-500 focus:ring-2 focus:ring-blue-500 bg-white text-black"
      }`}
  />
</div>

  {/* Three fields in a row */}
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
    {/* Initial Sync Date */}
    <div>
      <label className="block text-gray-600 mb-1">Initial Sync Date</label>
      <input
        type="date"
        value={initial_sync_date}
        onFocus={() => setActiveField("initial_sync_date")}
        disabled={!isEditMode && selectedAsset}
        onChange={(e) => {
          setinitial_sync_date(e.target.value);
          onDirtyChange(true); 
          setModifiedFields(prev => ({ ...prev, initial_sync_date: true }));
        }}
        placeholder="Initial Sync Date"
        className={`w-full p-3 pl-4 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
          ${!isEditMode
            ? "bg-[#f9f9f9] text-gray-800 border-gray-300" 
            : isEditMode && (activeField === "initial_sync_date"|| modifiedFields.initial_sync_date)
              ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
              : "bg-white text-black border-blue-500"}`}
      />
    </div>

    {/* Commercial Date */}
    <div>
      <label className="block text-gray-600 mb-1 truncate min-h-[20px]">Commercial Date</label>
      <input
        type="date"
        value={commercial_operating_date}
        onFocus={() => setActiveField("commercial_operating_date")}
        disabled={!isEditMode && selectedAsset}
        onChange={(e) => {
          setcommercial_operating_date(e.target.value);
          onDirtyChange(true); 
          setModifiedFields(prev => ({ ...prev, commercial_operating_date: true }));
        }}
        className={`w-full p-3 pl-4 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
          ${!isEditMode
            ? "bg-[#f9f9f9] text-gray-800 border-gray-300" 
            : isEditMode && (activeField === "commercial_operating_date"|| modifiedFields.commercial_operating_date)
              ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
              : "bg-white text-black border-blue-500"}`}
      />
    </div>

    {/* Retirement Date */}
    <div>
      <label className="block text-gray-600 mb-1">Retirement Date</label>
      <input
        type="date"
        value={retirement_date}
        onFocus={() => setActiveField("retirement_date")}
        disabled={!isEditMode && selectedAsset}
        onChange={(e) => {
          setretirement_date(e.target.value);
          onDirtyChange(true); 
          setModifiedFields(prev => ({ ...prev, retirement_date: true }));
        }}
        placeholder="Retirement Date"
        className={`w-full p-3 pl-4 pr-10 border rounded-lg text-sm transition-all ease-in-out duration-300 shadow-inner appearance-none 
          ${group_status_code?.toLowerCase?.() === "retired" && !retirement_date && isEditMode
            ? "border-red-500 focus:ring-red-500 bg-white text-black"
            : !isEditMode
              ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
              : (activeField === "retirement_date" || modifiedFields.retirement_date)
                ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                : "border-blue-500 focus:ring-2 focus:ring-blue-500 bg-white text-black"
          }`}
      />
    </div>
  </div>
</div>

        </div>
        {/* Control and Communication Types sheduling */}
        <div className="p-6 bg-[#f9f9f9] border border-gray-300 rounded-lg shadow-sm mt-5">
  <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
    <div className="flex flex-col">
      <label className="block text-gray-600 text-sm mb-2 truncate min-h-[20px]">Control Type</label>
      <ControlTypeDropdown
        selectedControlType={control_type_code}
        // onControlTypeChange={(control_type_code) => setControlTypeCode(control_type_code)}
        onControlTypeChange={(control_type_code) => {
          setControlTypeCode(control_type_code);
          onDirtyChange(true);
          setModifiedFields(prev => ({ ...prev, control_type_code: true })); 
        }}
        onFocus={() => setActiveField("control_type_code")}
        disabled={!isEditMode && selectedAsset}
        className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
          !isEditMode
            ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
            : isEditMode && (activeField === "control_type_code"|| modifiedFields.control_type_code)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                  : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
        }`}
      />
    </div>

    <div className="flex flex-col">
      <label className="block text-gray-600 text-sm mb-2 truncate min-h-[20px]">Communication Type</label>
      <CommunicationTypeDropdown
        selectedCommunicationType={communication_type_code}
        onCommunicationTypeChange={(communication_type_code) => {
          setCommunicationTypeCode(communication_type_code);
          onDirtyChange(true); 
          setModifiedFields(prev => ({ ...prev, communication_type_code: true }));
        }}
        onFocus={() => setActiveField("communication_type_code")}
        disabled={!isEditMode && selectedAsset}
        className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
          !isEditMode
            ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
            : isEditMode && (activeField === "communication_type_code"|| modifiedFields.communication_type_code)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                  : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
        }`}
      />
    </div>

    <div className="flex flex-col">
      <label className="block text-gray-600 text-sm mb-2 truncate min-h-[20px]">Scheduling Type</label>
      <SchedulingTypeDropdown
        selectedSchedulingType={scheduling_type_code}
        onSchedulingTypeChange={(scheduling_type_code) => {
          setSchedulingTypeCode(scheduling_type_code);
          onDirtyChange(true); 
          setModifiedFields(prev => ({ ...prev, scheduling_type_code: true }));
        }}
        onFocus={() => setActiveField("scheduling_type_code")}
        disabled={!isEditMode && selectedAsset}
        className={`w-full p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
          !isEditMode
            ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
            : isEditMode && (activeField === "scheduling_type_code"|| modifiedFields.scheduling_type_code)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                  : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
        }`}
      />
    </div>
  </div>


        </div>
      </div>

    </form>
  );
};

export default AssetForm;
